var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#7d7d7d",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 2.83333c-5.06261 0-9.16667 4.10406-9.16667 9.16667 0 5.0626 4.10406 9.1667 9.16667 9.1667 5.0626 0 9.1667-4.1041 9.1667-9.1667 0-5.06261-4.1041-9.16667-9.1667-9.16667zm-10 9.16667c0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.659 7.19351c.16558-.1598.42936-.1551.58916.01049.77134.79934 1.76794 1.34479 2.85694 1.56376 1.0891.21897 2.219.10108 3.2394-.338.2114-.09095.4564.00667.5474.21805s-.0067.45647-.218.54743c-1.1759.50598-2.478.64185-3.733.3895-1.2551-.25234-2.40345-.88092-3.29239-1.80207-.1598-.16559-.1551-.42936.01049-.58916z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 6.16667c-1.7259 0-3.125 1.39911-3.125 3.125 0 1.72593 1.3991 3.12503 3.125 3.12503s3.125-1.3991 3.125-3.12503c0-1.72589-1.3991-3.125-3.125-3.125zm-3.95833 3.125c0-2.18613 1.7722-3.95834 3.95833-3.95834 2.1861 0 3.9583 1.77221 3.9583 3.95834s-1.7722 3.95833-3.9583 3.95833c-2.18613 0-3.95833-1.7722-3.95833-3.95833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.66168 14.6347c.99863-.6324 2.15632-.9681 3.33832-.9681s2.3397.3357 3.3383.9681c.9986.6323 1.7971 1.5353 2.3025 2.6038.0984.208.0095.4564-.1985.5548s-.4564.0095-.5548-.1985c-.4379-.9258-1.1297-1.7082-1.995-2.2561s-1.8684-.8388-2.8925-.8388-2.02723.2909-2.8925.8388c-.86526.5479-1.55711 1.3303-1.99501 2.2561-.09839.208-.34679.2969-.55481.1985-.20803-.0984-.2969-.3468-.1985-.5548.50539-1.0685 1.30388-1.9715 2.3025-2.6038z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfile);
export default __webpack_public_path__ + "static/media/ico_profile.a51ebfd6c1a18a98e1bca4439374bc0e.svg";
export { ForwardRef as ReactComponent };